export default __webpack_public_path__ + "static/business_loans-7036ac9435d7273f57602ec8c38dc092.png";